export default __webpack_public_path__ + "7c6b7e6113d65899763c13da2ad44e73.png";